import { IConfig } from '@cian/config/shared';

export const isStarredFlagEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.starredFlag.Enabled'));
};
